import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import ar from './locales/ar.json'

Vue.use(VueI18n)

const messages = {
  en,
  ar
}
const savedLocale = localStorage.getItem('selectedLocale') || 'ar';

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'ar',
  messages
})

export default i18n
